// extracted by mini-css-extract-plugin
module.exports = {"container":"NiceBox_container__1ouw3"};